import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldOff, ArrowLeft } from 'lucide-react';

export default function AccessDeniedPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-rose-50 flex items-center justify-center px-4">
      <div className="w-full max-w-xl rounded-3xl border border-rose-200 bg-white p-8 shadow-xl">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-rose-100 text-rose-700">
          <ShieldOff size={28} />
        </div>

        <h1 className="text-center text-2xl font-black text-slate-900">Access Restricted</h1>
        <p className="mt-3 text-center text-sm leading-6 text-slate-600">
          You do not have permission to access this module.
        </p>
        <p className="mt-1 text-center text-sm leading-6 text-slate-600">
          Access denied by Organization Admin or Organization Head.
        </p>

        <div className="mt-6 flex justify-center">
          <Link
            to="/dashboard"
            className="inline-flex items-center gap-2 rounded-xl bg-rose-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-rose-700"
          >
            <ArrowLeft size={16} />
            Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
